import { useState } from 'react';

/** What a list endpoint answers with `includeTotal` on its first page. */
export interface ListTotal {
  total?: number | undefined;
  totalCapped?: boolean | undefined;
}

/**
 * The total of a cursor list across its pages: the endpoint counts on the first page only
 * (`includeTotal`), so the number is kept while the cursor moves and dropped when the query
 * changes. `queryKey` identifies the query without its cursor; `page` is the loaded page, ignored
 * while it is placeholder data of another query.
 */
export function useKeptTotal(
  queryKey: string,
  page: ListTotal | undefined,
  isPlaceholderData: boolean,
): ListTotal {
  const [kept, setKept] = useState<{ key: string; total: number; totalCapped: boolean } | null>(
    null,
  );
  const fresh = !isPlaceholderData && page?.total !== undefined ? page.total : undefined;
  const freshCapped = page?.totalCapped === true;
  if (
    fresh !== undefined &&
    (kept?.key !== queryKey || kept.total !== fresh || kept.totalCapped !== freshCapped)
  ) {
    setKept({ key: queryKey, total: fresh, totalCapped: freshCapped });
  }
  if (fresh !== undefined) return { total: fresh, totalCapped: freshCapped };
  return kept?.key === queryKey ? { total: kept.total, totalCapped: kept.totalCapped } : {};
}
